import Vue from "vue";
import VueI18n from "vue-i18n";
import cookies from "@/utils/cookie";
import elementLocale from 'element-ui/lib/locale'
import { Locale as vantLocale } from 'vant';

Vue.use(VueI18n);

// 引入各个语言配置文件
import en from "./en.json"; // 英语
import zh from "./zh.json"; // 简体中文
import tw from "./tw.json"; // 繁体中文
import es from "./es.json"; // 西班牙语
import fr from "./fr.json"; // 法语
import id from "./id.json"; // 印度语
import th from "./th.json"; // 泰语
import ar from "./ar.json"; // 阿拉伯语
import pt from "./pt.json"; // 葡萄牙语
import ru from "./ru.json"; // 俄语

// 语言映射表
const elementUIMap = {
  zh: "zh-CN",
  tw: "zh-TW",
  es: "es",
  en: "en",
  fr: "fr",
  id: "id",
  th: "th",
  ar: "ar",
  pt: "pt",
  ru: "ru-RU"
};

const vantUIMap = {
  zh: "zh-CN",
  tw: "zh-TW",
  es: "es-ES",
  en: "en-US",
  fr: "fr-FR",
  id: "id-ID",
  th: "th-TH",
  ar: "ar-AR",
  pt: "pt-PT",
  ru: "ru-RU"
};

const messages = {
  en,
  zh,
  tw,
  es,
  fr,
  id,
  th,
  ar,
  pt,
  ru
}

const getMappedId = (locale, map) => {
  return map[locale] || locale;
};

// 获取当前语言
export function getLanguage() {
  const chooseLanguage = cookies.get('lang') || localStorage.getItem("locale")
  if (chooseLanguage) return chooseLanguage

  // 如果没有选择语言
  const language = (navigator.language || navigator.browserLanguage).toLowerCase()
  const locales = Object.keys(messages)
  for (const locale of locales) {
    if (language.indexOf(locale) > -1) {
      return locale
    }
  }
  
  // App 内嵌环境判断
  if (navigator.userAgent.indexOf('umoocApp') > -1) {
    try {
      let ua = navigator.userAgent
      if (ua.indexOf('-language-') > -1) {
        let lang = ua.split('-language-')[1].split(' ')[0]
        if (lang) return lang
      }
    } catch (error) {
      console.log(error)
    }
  }

  return 'zh'
}

export const lang = getLanguage()

// 创建vue-i18n实例i18n
const i18n = new VueI18n({
  // 设置默认语言
  locale: lang,
  // 添加多语言（每一个语言标示对应一个语言文件）
  messages,
  silentTranslationWarn: true
});

// 异步加载 UI 组件库语言包
export function loadLanguageAsync(lang) {
  const elementUILang = getMappedId(lang, elementUIMap);
  const vantUILang = getMappedId(lang, vantUIMap);

  // 设置 i18n 语言
  if (i18n.locale !== lang) {
    i18n.locale = lang
  }
  
  return Promise.all([
    // 动态加载 Element UI 语言包
    import(/* webpackChunkName: "lang-element-[request]" */ `element-ui/lib/locale/lang/${elementUILang}`),
    // 动态加载 Vant UI 语言包
    import(/* webpackChunkName: "lang-vant-[request]" */ `vant/lib/locale/lang/${vantUILang}`).catch(() => {
        console.warn(`Vant language pack for ${lang} not found.`);
        return import(`vant/lib/locale/lang/zh-CN`); 
    })
  ]).then(([elementMsg, vantMsg]) => {
    elementLocale.use(elementMsg.default);
    if (vantMsg && vantMsg.default) {
        vantLocale.use(vantUILang, vantMsg.default);
    }
    return lang;
  });
}

export default i18n;


